import { $findAll } from 'fxdom/es';
import { each, go } from 'fxjs/es';

export const selectCategoryTabEvent = (el) => {
  const url = new URL(location.href);

  go(
    el,
    $findAll('.omp-cell__category-tab'),
    each(($tab) => {
      $tab.addEventListener('click', (e) => {
        localStorage.setItem('category_focus', 'true');
        const { key } = e.currentTarget.dataset;
        url.searchParams.set('offset', 0);
        url.searchParams.set('limit', 10);
        url.searchParams.delete('filter_type');
        if (key && key !== 'ALL') url.searchParams.set('filter_type', key);
        location.href = url.toString();
      });
    }),
  );
};
